import { PageModels } from '@/context/PageModels/PageModels.interface';
import { Page as BrPage } from '@bloomreach/spa-sdk';
import { resolveAlternativeLanguageCodes } from './translation';

const parseConfigAndLabels = (
  resourceBundles: any,
  models: any,
): { config: Record<string, any>; labels: Record<string, any> } =>
  resourceBundles
    .split(',')
    .filter((key: string) => /.config$/i.test(key) || /.labels$/i.test(key))
    .reduce(
      (a: any, b: string) => {
        const obj = a;

        if (/.config$/i.test(b)) {
          obj.config = {
            ...a.config,
            [b.replace('.config', '')]: models[b],
          };
        }

        if (/.labels$/i.test(b)) {
          obj.labels = {
            ...a.labels,
            [b.replace('.labels', '')]: models[b],
          };
        }

        return obj;
      },
      {
        config: {},
        labels: {},
      },
    );

const resolvePageModels = (page?: BrPage): PageModels => {
  const models = page?.getComponent()?.getModels<Record<string, any>>();
  const {
    componentParameterMap,
    taxonomyDocument: taxonomy,
    'value-lists/es---custom-labels': esCustomLabels,
    'value-lists/language-labels': languageLabels,
    'value-lists/crm-read-whitelist': crmReadWhitelist,
    'global-rounded-style-blacklist': globalRoundedStyleBlacklist,
    'http-status-code': httpStatusCode = '200',
    mountLocale = '',
    redirectTo: langToRedirect = '',
    content_group: contentGroup,
    content_group2: contentGroup2,
    content_group3: contentGroup3,
    content_group4: contentGroup4,
    'marketo-contact-info-prefill': marketoContactInfoPrefill,
    'datalayer-event-blacklist': datalayerEventBlacklist,
    'taxonomies---content-category-card-date-field-mapper': contentCategoryCardDateFieldMapper,
    'taxonomies---content-category-card-date-label-mapper': contentCategoryCardDateLabelMapper,
  } = models || {};
  const { resourceBundles = '' } = componentParameterMap || {};
  const language = mountLocale.substring(0, 2);
  const { labels, config } = parseConfigAndLabels(resourceBundles, models);

  const { translation: translationConfig } = config;

  const languageConfig = {
    siteLanguage: language,
    alternativeLanguageCodes: resolveAlternativeLanguageCodes({ raw: translationConfig }),
  };

  return {
    config,
    labels,
    taxonomy,
    esLabels: { ...taxonomy, ...esCustomLabels },
    languages: { languageLabels },
    crmReadWhitelist,
    httpStatusCode,
    language,
    langToRedirect,
    contentGroup,
    contentGroup2,
    contentGroup3,
    contentGroup4,
    marketoContactInfoPrefill,
    globalRoundedStyleBlacklist,
    datalayerEventBlacklist: Object.keys(datalayerEventBlacklist || {}),
    contentCategoryCardDateFieldMapper,
    contentCategoryCardDateLabelMapper,
    languageConfig,
    ready: false,
  };
};

export default resolvePageModels;
